// extracted by mini-css-extract-plugin
module.exports = {"red":"#ff5370"};